import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { v4 } from 'uuid';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

import axios from '../../services/axios';
import Loading from '../../components/Loading';
import ErrorProcessor from '../../components/ErrorProcessor';
import Pill from '../../components/Dashboards/Pill';
import BarChart from '../../components/Charts/BarChart';
import DonutChart from '../../components/Charts/DonutChart';
import Activity from '../../components/Activity';

export default function DashCustomers() {
  const [isLoading, setIsLoading] = useState(false);
  const [apiErrors, setApiErrors] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [data, setData] = useState([]);

  const getData = useCallback(async (loading = true) => {
    if (loading) {
      setIsLoading(true);
    }
    try {
      const request = await axios.get(`/customers/dashboards`);
      console.log(request);
      setData(request.data);
    } catch (err) {
      setApiErrors(err);
    } finally {
      setIsLoading(false);
      setDataLoaded(true);
    }
  }, []);

  useEffect(() => {
    getData();
    // const intervalId = setInterval(() => {
    //   getData(false);
    // }, 60000);

    // return () => clearInterval(intervalId);
  }, [getData]);

  return (
    <div>
      <ErrorProcessor error={apiErrors} />
      <Loading isLoading={isLoading} />
      {dataLoaded && !apiErrors && (
        <>
          <Row className="mb-2">
            <Col xl={4} md={6} className="mb-4" key={v4()}>
              <Pill
                data={{
                  content: 'Clientes cadastrados',
                  name: data.totalCustomers,
                }}
                icon={faUser}
                color="primary"
                fullHeight
              />
            </Col>
            <Col xl={4} md={6} className="mb-4" key={v4()}>
              <Pill
                data={{
                  content: 'Clientes ativos',
                  name: data.totalActiveCustomers,
                }}
                icon={faUser}
                color="green"
                fullHeight
              />
            </Col>
            <Col xl={4} md={6} className="mb-4" key={v4()}>
              <Pill
                data={{
                  content: 'Clientes inativos',
                  name: data.totalInactiveCustomers,
                }}
                icon={faUser}
                color="red"
                fullHeight
              />
            </Col>
          </Row>
          <Row>
            <Col lg={7} className="mb-4 mb-lg-0">
              <Card className="h-100">
                <Card.Header>
                  <h4 className="card-heading">
                    Formas de desconto contratual por cliente
                  </h4>
                </Card.Header>
                <Card.Body>
                  <Row className="mb-5">
                    {data.totalByContractualDiscount.map((discount) => (
                      <Col
                        key={v4()}
                        xs={6}
                        sm="auto"
                        className="flex-sm-grow-1 border-start py-3 d-flex align-items-center"
                      >
                        <div>
                          <h3 className="subtitle text-gray-500 fw-normal">
                            {discount.ContractualDiscount.name}
                          </h3>
                          <div className="h4 fw-normal text-dark">
                            {discount.total.toLocaleString('pt-BR')}
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                  <BarChart
                    label="Total"
                    labels={data.totalByContractualDiscount.map(
                      (val) => val.ContractualDiscount.name
                    )}
                    values={data.totalByContractualDiscount.map(
                      (val) => val.total
                    )}
                  />
                </Card.Body>
              </Card>
            </Col>
            <Col lg={5} className="mb-4 mb-lg-0">
              <div className="h-50 pb-4 pb-lg-2" key={v4()}>
                <Card className="h-100">
                  <Card.Body className="d-flex">
                    <Row className="w-100 align-items-center">
                      <Col sm={5} className="mb-4 mb-sm-0">
                        <h2 className="mb-0 d-flex align-items-center">
                          <span>
                            {data.totalByContractStatus.status1.toLocaleString(
                              'pt-BR'
                            )}
                          </span>
                          <span className="dot bg-green d-inline-block ms-3" />
                        </h2>
                        <span className="text-muted text-uppercase small">
                          Adimplente
                        </span>
                        <hr />
                        <small className="text-muted">
                          Clientes com pagamentos contratuais em dia
                        </small>
                      </Col>
                      <Col sm={7}>
                        <DonutChart
                          labels={['Adimplentes', 'Inadimplentes']}
                          values={[
                            data.totalByContractStatus.status1,
                            data.totalByContractStatus.status0,
                          ]}
                          color={['green', 'lightGray']}
                          cutout="90%"
                          hideLegend
                          noDatasetBorder
                        />
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </div>
              <div className="h-50 pt-lg-2" key={v4()}>
                <Card className="h-100">
                  <Card.Body className="d-flex">
                    <Row className="w-100 align-items-center">
                      <Col sm={5} className="mb-4 mb-sm-0">
                        <h2 className="mb-0 d-flex align-items-center">
                          <span>
                            {data.totalByContractStatus.status0.toLocaleString(
                              'pt-BR'
                            )}
                          </span>
                          <span className="dot bg-red d-inline-block ms-3" />
                        </h2>
                        <span className="text-muted text-uppercase small">
                          Inadimplente
                        </span>
                        <hr />
                        <small className="text-muted">
                          Clientes com pagamentos contratuais em atraso
                        </small>
                      </Col>
                      <Col sm={7}>
                        <DonutChart
                          labels={['Inadimplentes', 'Adimplentes']}
                          values={[
                            data.totalByContractStatus.status0,
                            data.totalByContractStatus.status1,
                          ]}
                          color={['red', 'lightGray']}
                          cutout="90%"
                          hideLegend
                          noDatasetBorder
                        />
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={9} className="mt-4 mb-4 mb-lg-0">
              <Card className="h-100">
                <Card.Header>
                  <h4 className="card-heading">Clientes cadastrados por UF</h4>
                </Card.Header>
                <Card.Body>
                  <Row className="mb-5">
                    {data.totalByState.map((customer) => (
                      <Col
                        key={v4()}
                        xs={6}
                        sm="auto"
                        className="flex-sm-grow-1 border-start py-3 d-flex align-items-center"
                      >
                        <div>
                          <h3 className="subtitle text-gray-500 fw-normal">
                            {customer.state}
                          </h3>
                          <div className="h4 fw-normal text-dark">
                            {customer.total.toLocaleString('pt-BR')}
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                  <BarChart
                    label="Total"
                    labels={data.totalByState.map((val) => val.state)}
                    values={data.totalByState.map((val) => val.total)}
                  />
                </Card.Body>
              </Card>
            </Col>
            <Col xl={3} className="mt-4 mb-4 mb-lg-0">
              <div className="card-adjust-height-xl">
                <Activity
                  title="Pagamentos em atraso"
                  data={data.last30PaymentHistoryFail.map((val) => {
                    return {
                      name: <div>{val.status_description} </div>,
                      time: moment.utc(val.payment_date).format('DD/MM/YYYY'),
                      text: `${val.Customer.name} ${val.Customer.lastname}`,
                      link: `/customers/${val.customer_id}/edit`,
                    };
                  })}
                  appendHeader={
                    <Col sm={12} className="mt-2">
                      <h6 className="subtitle text-gray-500">
                        Últimos 30 pagamento em atraso
                      </h6>
                    </Col>
                  }
                />
              </div>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
}
